import {styled, CSSObject} from "@mui/material/styles"
import {Typography} from "@mui/material"
import merge from "lodash/merge"
import {HeadingStyles} from "./models"
import {removeUnsetProps} from "../utils"

export const MockSearchBannerWrapper = styled("div")({
    display: "flex",
    maxWidth: "1200px",
})

export const StyledHeading = styled(Typography, {shouldForwardProp: prop => !String(prop).startsWith("$")})<{
    $headingStyles?: HeadingStyles
    // workaround for not picking up component from <Typography />
    component?: string
}>(({theme, $headingStyles = {}}) => {
    const override = removeUnsetProps({
        textAlign: $headingStyles?.alignment,
        color: $headingStyles?.textColor,
        textDecoration: $headingStyles?.textDecoration,
        textTransform: $headingStyles?.textTransform,
        fontSize: $headingStyles?.fontSize,
        fontWeight: $headingStyles?.fontWeight,
        letterSpacing: $headingStyles?.letterSpacing,
    }) as CSSObject
    return merge(
        {
            overflow: "hidden",
            textTransform: "uppercase",
            textOverflow: "ellipsis",
            textAlign: "center",
            textWrap: "nowrap",
            width: "100%",
            paddingRight: "1rem",
            paddingLeft: "1rem",
            paddingBottom: "1rem",
            color: theme.colours.plp.searchBanner.default.banner.copyText.textColor,
        },
        override,
    )
})
